import { Rect } from 'dragonmouse-shared/geometry';
import styled from 'styled-components';
import { unthemed } from 'tokens';

interface BaseProps {
	cursor?: string;
}

export const Base = styled.div<BaseProps>`
	position: absolute;
	width: 100%;
	height: 100%;
	overflow: hidden;
	cursor: ${(p) => p.cursor || 'auto'};
`;

export const Box = styled.div`
	width: 222px;
	height: 90px;
	background: #ff0000;
`;

interface DragObjectProps {
	canvasRect: Rect;
}
export const DragObject = styled.div<DragObjectProps>`
	position: absolute;
	top: ${(p) => p.canvasRect.y}px;
	left: ${(p) => p.canvasRect.x}px;
	width: ${(p) => p.canvasRect.width}px;
	height: ${(p) => p.canvasRect.height}px;
	border: 1px solid ${unthemed.gray[1000]};
	background-color: ${unthemed.gray[700]};
	opacity: 0.3;
	pointer-events: none;
`;

interface SelectionBoxProps {
	canvasRect: Rect;
}
export const SelectionBox = styled.div<SelectionBoxProps>`
	position: absolute;
	top: ${(p) => p.canvasRect.y}px;
	left: ${(p) => p.canvasRect.x}px;
	width: ${(p) => p.canvasRect.width}px;
	height: ${(p) => p.canvasRect.height}px;
	background-color: ${unthemed.blue[700]}20;
	border: 1px solid ${unthemed.blue[500]};
	pointer-events: none;
`;
